import { render, staticRenderFns } from "./RulesOfResidence.vue?vue&type=template&id=4683a3e8&scoped=true&"
import script from "./RulesOfResidence.vue?vue&type=script&lang=js&"
export * from "./RulesOfResidence.vue?vue&type=script&lang=js&"
import style0 from "./RulesOfResidence.vue?vue&type=style&index=0&id=4683a3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683a3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox,VCol,VContainer,VRow})
